module.exports = __webpack_public_path__ + "static/media/report_free_comment.b6fa7a9b.svg";